import React, { useEffect } from "react";
import Signinform from "../components/signinform";

function SignIn() {
  useEffect(() => {
    document.title = "Sign In";
  }, []);
  return (
    <div className="sign-in-from">
      <Signinform />
    </div>
  );
}

export default SignIn;
